import { MutationCache, QueryCache, QueryClient } from '@tanstack/react-query'

import { UnauthorizedError } from 'lib/apiClient'
import { auth } from 'lib/auth'

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      retry: false,
    },
  },
  queryCache: new QueryCache({
    onError: err => {
      if (err instanceof UnauthorizedError) {
        auth.redirectToSignIn()
      }
    },
  }),
  mutationCache: new MutationCache({
    onError: err => {
      if (err instanceof UnauthorizedError) {
        auth.redirectToSignIn()
      }
    },
  }),
})
